/**
 * Tipo de idade
 * - Anos, Meses, Dias.
 */
const ANOS = { name: 'Anos', value: 'ANOS', short: 'A', isDefault: true }
const MESES = { name: 'Meses', value: 'MESES', short: 'M' }
const DIAS = { name: 'Dias', value: 'DIAS', short: 'D' }

const TIPOS_IDADE = [ ANOS, MESES, DIAS ]

export default TIPOS_IDADE
